// IndexedDB-backed offline capture queue for ReasonVisionX (Phase 9).
// Stores JSON capture payloads while offline and replays them on reconnect.
// Strictly additive — used only when the network is unavailable.

const DB_NAME = 'rvx-offline';
const STORE = 'captureQueue';
const DB_VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: 'id' });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(db, mode) {
  return db.transaction(STORE, mode).objectStore(STORE);
}

// type: 'object-intel' | 'live-measure'
export async function enqueueCapture({ type, projectId, projectName, payload, label }) {
  const db = await openDB();
  const record = {
    id: (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `q-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    type,
    projectId,
    projectName: projectName || '',
    label: label || '',
    payload,
    createdAt: new Date().toISOString(),
  };
  return new Promise((resolve, reject) => {
    const store = tx(db, 'readwrite');
    const r = store.add(record);
    r.onsuccess = () => resolve(record);
    r.onerror = () => reject(r.error);
  });
}

export async function getAllCaptures() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const r = tx(db, 'readonly').getAll();
    r.onsuccess = () => resolve((r.result || []).sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1)));
    r.onerror = () => reject(r.error);
  });
}

export async function countCaptures() {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const r = tx(db, 'readonly').count();
    r.onsuccess = () => resolve(r.result || 0);
    r.onerror = () => reject(r.error);
  });
}

export async function removeCapture(id) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const r = tx(db, 'readwrite').delete(id);
    r.onsuccess = () => resolve(true);
    r.onerror = () => reject(r.error);
  });
}
